import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import { useI18n } from "../i18n";
import { Trash2, Minus, Plus, ArrowRight } from "lucide-react";

const Cart = () => {
  const { lines, setQty, remove, subtotal } = useCart();
  const { t, lang } = useI18n();

  if (lines.length === 0) {
    return (
      <div className="max-w-[900px] mx-auto px-6 py-24 text-center" data-testid="cart-page-empty">
        <h1 className="font-display text-5xl tracking-tighter font-light">{t("cart")}</h1>
        <p className="mt-4 text-ink-muted">{t("cart_empty")}</p>
        <Link to="/shop" className="btn-primary mt-8 text-sm">{t("continue_shopping")}</Link>
      </div>
    );
  }

  return (
    <div className="max-w-[1200px] mx-auto px-6 lg:px-12 py-12" data-testid="cart-page">
      <h1 className="font-display text-5xl tracking-tighter font-light mb-10">{t("cart")}</h1>
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-8 divide-y divide-black/10 border-t border-b border-black/10">
          {lines.map((l) => (
            <div key={l.product_id} className="py-5 flex items-start gap-4" data-testid={`cart-line-${l.product_id}`}>
              <Link to={`/product/${l.snapshot.slug}`} className="w-24 h-28 bg-secondary-warm overflow-hidden shrink-0">
                <img src={l.snapshot.image} alt="" className="w-full h-full object-cover" />
              </Link>
              <div className="flex-1 min-w-0">
                <Link to={`/product/${l.snapshot.slug}`} className="font-display text-xl block leading-tight hover:text-terracotta">{lang === "nl" ? l.snapshot.name_nl : l.snapshot.name_en}</Link>
                <div className="text-sm text-ink-muted mt-1">€{l.snapshot.price.toFixed(2)}</div>
                <div className="mt-3 flex items-center gap-3">
                  <div className="flex items-center border border-ink">
                    <button onClick={() => setQty(l.product_id, l.qty - 1)} data-testid={`cart-decrement-${l.product_id}`} className="w-8 h-9 flex items-center justify-center"><Minus className="w-3.5 h-3.5" /></button>
                    <div className="w-9 text-center text-sm">{l.qty}</div>
                    <button onClick={() => setQty(l.product_id, l.qty + 1)} data-testid={`cart-increment-${l.product_id}`} className="w-8 h-9 flex items-center justify-center"><Plus className="w-3.5 h-3.5" /></button>
                  </div>
                  <button data-testid={`cart-remove-${l.product_id}`} onClick={() => remove(l.product_id)} className="text-ink-muted hover:text-terracotta text-xs flex items-center gap-1"><Trash2 className="w-3.5 h-3.5" /> {lang === "nl" ? "Verwijder" : "Remove"}</button>
                </div>
              </div>
              <div className="font-display text-lg shrink-0">€{(l.qty * l.snapshot.price).toFixed(2)}</div>
            </div>
          ))}
        </div>
        <aside className="md:col-span-4">
          <div className="bg-white border border-black/10 p-6 sticky top-32">
            <div className="font-display text-2xl mb-5">{t("checkout")}</div>
            <div className="flex justify-between text-sm py-2"><span>{t("subtotal")}</span><span data-testid="cart-subtotal">€{subtotal.toFixed(2)}</span></div>
            <div className="flex justify-between text-sm py-2 text-ink-muted"><span>{t("shipping")}</span><span>{lang === "nl" ? "Berekend bij afrekenen" : "Calculated at checkout"}</span></div>
            <div className="border-t border-black/10 mt-3 pt-3 flex justify-between font-display text-lg"><span>{t("total")}</span><span>€{subtotal.toFixed(2)}</span></div>
            <Link to="/checkout" data-testid="go-to-checkout" className="btn-primary w-full mt-5 text-sm">{t("checkout")} <ArrowRight className="w-4 h-4" /></Link>
            <Link to="/shop" className="block text-center text-xs font-label mt-3 text-ink-muted hover:text-ink">{t("continue_shopping")}</Link>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Cart;
